import { render, staticRenderFns } from "./pain-assessment.vue?vue&type=template&id=bcb1becc&"
import script from "./pain-assessment.vue?vue&type=script&lang=js&"
export * from "./pain-assessment.vue?vue&type=script&lang=js&"
import style0 from "./pain-assessment.vue?vue&type=style&index=0&lang=css&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports